import Vue from 'vue';
import Component from "vue-class-component";
import { Watch, Prop } from "vue-property-decorator";
import ABaseComponent from "Components/Base/ABaseComponent";
import { State, Getter, Action } from "vuex-class";
import { PorterBuilderState } from "Store/types";
import porterBuilder from 'Store/porterbuilder/porterbuilder';

@Component({})
export default class PorterBuilderBarComponent extends ABaseComponent {
    initialLoad: boolean = false;

    get porterId(){
        return porterBuilder.state.porterId;
    }

    get porter() {
        return porterBuilder.state.porter.porter;
    }

    get fullName() {
        const firstName = porterBuilder.state.porter.porter.firstName;
        const lastName = porterBuilder.state.porter.porter.lastName;
        return `${firstName} ${lastName}`;
    }

    created() {
        porterBuilder.dispatchInitializePorter().then(() => {
            this.initialLoad = porterBuilder.state.porterId ? false : true;
            this.loading = false;
        });
    }

    clearPorter() {
        porterBuilder.dispatchClearPorter();
    }
}
Vue.component("porter-builder-bar", PorterBuilderBarComponent);